import { API_URL } from "./api";
import { UserSession } from "../types";

export const fetchCurrentUser = async (): Promise<UserSession | null> => {
  try {
    const res = await fetch(`${API_URL}/auth/me`, {
      credentials: "include",
    });
    if (!res.ok) return null;
    return (await res.json()) as UserSession;
  } catch {
    return null;
  }
};

export const logout = async (): Promise<void> => {
  try {
    await fetch(`${API_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
  } catch {
    // ignore
  }
};

export const startGoogleLoginWithPrompt = () => {
  window.location.href = `${API_URL}/auth/google/login?prompt=select_account`;
};

export const startGoogleLogin = () => {
  window.location.href = `${API_URL}/auth/google/login`;
};
